import React from 'react';

import {
  GridActionButton,
  GridRightPanelProps,
} from 'components/grid/grid-types';
import { GridRightPanelCart } from 'modules/archival-unit/action-buttons/cart-info';
import { EadNode } from 'types';

import { EadQuote } from './ead-quote';
import { EadFavourite } from './ead-favourite';

import { archivalUnitConfig } from 'modules/archival-unit/archival-unit-grid';
import { renderActionButtons } from 'components/grid/right-panel/action-buttons-factory';
import { ArchivalAidDownload } from '../archival-aid-download';

export const eadActionButtons: GridActionButton[] = [
  { id: 'favourite', Component: EadFavourite },
  { id: 'grid-cart', Component: GridRightPanelCart },
  { id: 'quote', Component: EadQuote },
  { id: 'download', Component: ArchivalAidDownload },
];

export const EadActionButtons = (props: GridRightPanelProps) => {
  const ead = props.item as EadNode;

  const ArchivalUnitButtons = archivalUnitConfig.ActionButtons ?? (() => <></>);

  if (ead.publicCopy) {
    const archivalUnitButtonProps: GridRightPanelProps = {
      ...props,
      item: ead.publicCopy,
    };
    return <ArchivalUnitButtons {...archivalUnitButtonProps} />;
  }

  return renderActionButtons(eadActionButtons, props);
};
